const amount = (value) => Number.isFinite(Number(value)) ? Number(value) : 0;

export function calculateLevelCompensation(level = {}) {
  const safeLevel = level || {};
  const additionalAllowances = Array.isArray(safeLevel.additionalAllowances) ? safeLevel.additionalAllowances.reduce((sum, item) => sum + amount(item?.amount), 0) : 0;
  const basicSalary = amount(safeLevel.basicSalary || safeLevel.salaryStructure);
  const housingAllowance = amount(safeLevel.housingAllowance);
  const transportAllowance = amount(safeLevel.transportAllowance);
  const grossPay = basicSalary + housingAllowance + transportAllowance + amount(safeLevel.otherAllowance) + additionalAllowances;
  const tax = grossPay * amount(safeLevel.taxRate) / 100;
  const pension = (basicSalary + housingAllowance + transportAllowance) * amount(safeLevel.pensionRate) / 100;
  const deductions = amount(safeLevel.recurringDeduction) + tax + pension;
  return { additionalAllowances, grossPay, deductions, illustrativeNetPay: Math.max(0, grossPay - deductions) };
}
